import { Typography } from '@material-ui/core';
import styled from '@emotion/styled';
import { FlexContainer } from '../../../../../layout/Flex';

const EmptyStateContainer = styled(FlexContainer)`
  @media (min-width: 600px) {
    min-height: 50vh;
  }
`;

const TypographyGray = styled(Typography)`
  color: ${(p) => p.theme.custom.colors.gray.w500};
`;

export const EmptyState = ({
  title,
  instruction
}: {
  title: string;
  instruction: string;
}) => (
  <EmptyStateContainer
    alignItems="center"
    direction="column"
    justifyContent="center"
    fullWidth
  >
    <TypographyGray variant="h2">{title}</TypographyGray>
    <TypographyGray>{instruction}</TypographyGray>
  </EmptyStateContainer>
);
